import { register } from '../../../JavaScript/Utils'

export const JobSearch = (el: HTMLElement) => {
  const filterAccordions: NodeListOf<HTMLElement> = el.querySelectorAll('.comp-job-search--filter-slide')
  const buttonReset = el.querySelector('button.btn[type="reset"]');
  const form = el.querySelector("form");
  const checkboxes = Array.from(form.elements).filter((el) => el instanceof HTMLInputElement && el.type === "checkbox") as HTMLInputElement[];
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const tx_blsjobs_joblist = urlParams.get("tx_blsjobs_joblist[controller]");
  const results = document.querySelector(".comp-job-teaser");
  const isViewPortMobile = window.innerWidth < 768;


  // Searcb submitted? Scroll to results
  if (isViewPortMobile && tx_blsjobs_joblist && results) {
      results.parentElement.scrollIntoView({ behavior: "smooth" });
  }

  buttonReset.addEventListener("click",(event)=> {
    event.preventDefault();
    form.reset();
    for (const checkbox of checkboxes) {
      checkbox.checked = false;
    }
    form.dispatchEvent(new CustomEvent('reset-finished'));
  })

  const filterAccordion = (accordionElement: HTMLElement) => {
    const titleField = accordionElement.querySelector(".slide-title")
    const checkboxes: NodeListOf<HTMLInputElement> = accordionElement.querySelectorAll('input[type="checkbox"]')
    const defaultTitle = 'Alle'

    const updateInput = () => {
      const activeFilters: Array<string> = Array.from(checkboxes)
        .filter(input => input.checked)
        .map(input => input.dataset.name);

      titleField.textContent = activeFilters.length > 0 ? activeFilters.join(', ') : defaultTitle
    }

    checkboxes.forEach(input => {
      input.addEventListener("click", updateInput)
      form.addEventListener('reset-finished', updateInput)
    });
  }

  filterAccordions.forEach(accordion => filterAccordion(accordion))
}

register("JobSearch", JobSearch)
